import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import { VehicleOfficeSearchViewModel } from '@api/index';
import CarRentalAutoComplate from '@domain/carRental/searchBar/home/carRentalAutoComplate';

import { Wrapper, StyledContent } from './styled';
import MobileCarRentalSelection from './MobileCarRentalSelection';
export type CarRentalTypes = VehicleOfficeSearchViewModel | null;
export type AirportDataTypes = {
  label: string;
  onChange: (airport: CarRentalTypes) => void;
  activeLocation?: CarRentalTypes;
  history?: VehicleOfficeSearchViewModel[];
  clearPastFlightSearch?: () => void;
  removePastFlightSearch?: (item: VehicleOfficeSearchViewModel) => void;
  isLocationError?: boolean;
  setIsLocationError?: (value: boolean) => void;
  alignVertical?: boolean;
};

const CarRentalSelection: FC<AirportDataTypes> = ({
  label,
  onChange,
  activeLocation,
  history,
  clearPastFlightSearch,
  removePastFlightSearch,
  isLocationError,
  setIsLocationError,
  alignVertical = false,
}) => {
  const screen = useBreakpoint();

  return (
    <>
      {screen.xl ? (
        <StyledContent
          direction={screen.xs ? true : false}
          alignVertical={alignVertical}
        >
          <Wrapper alignVertical={alignVertical}>
            <CarRentalAutoComplate
              label={label}
              onChange={onChange}
              activeLocation={activeLocation}
              history={history}
              clearPastFlightSearch={clearPastFlightSearch}
              removePastFlightSearch={removePastFlightSearch}
              isLocationError={isLocationError}
              setIsLocationError={setIsLocationError}
            />
          </Wrapper>
        </StyledContent>
      ) : (
        <MobileCarRentalSelection
          label={label}
          onChange={onChange}
          history={history}
          clearPastFlightSearch={clearPastFlightSearch}
          removePastFlightSearch={removePastFlightSearch}
          activeLocation={activeLocation}
          isLocationError={isLocationError}
          setIsLocationError={setIsLocationError}
        />
      )}
    </>
  );
};

export default CarRentalSelection;
